import { call, put, takeEvery } from 'redux-saga/effects';
import { OrganizationsApi } from 'api';
import { apiCall } from 'store/utils';
import { getNextPageParams, sagasHandlersFactory } from 'store/entities/utils';
import * as actions from './actions';
import * as selectors from './selectors';

const handleGetOrganizationRequest = sagasHandlersFactory.createGetOneRequestHandler({
  actions: actions.getOrganization,
  request: OrganizationsApi.getOrganization,
});

// Custom (not the generic createGetOneRequestHandler) so the success action can carry the
// requested slug in `params` — the reducer keys isFetching/isFetched/byId by that slug, since
// it differs from the entity's real numeric id returned by the API.
function* handleGetOrganizationBySlugRequest(action: ReturnType<typeof actions.getOrganizationBySlug.request>): any {
  const slug = action.payload.id;

  try {
    const entity = yield apiCall(OrganizationsApi.getOrganizationBySlug, slug);
    yield put(actions.getOrganizationBySlug.success({ entity, params: { slug: String(slug) } }));
  } catch (error) {
    if (error instanceof Error) {
      yield put(actions.getOrganizationBySlug.failure({ error, notifyError: true, id: slug as number }));
    }
  }
}

const handleGetSearchOrganizationsRequest = sagasHandlersFactory.createGetManyRequestHandler({
  actions: actions.getSearchOrganizations,
  request: OrganizationsApi.getOrganizations,
  requestArgsBuilder: function* builder(action) {
    const { params } = action.payload;
    const { page_size, ...rest } = params;
    const { page } = yield call(getNextPageParams, page_size, selectors.searchOrganizationsState(), params);
    return {
      params: {
        ...rest,
        page,
        page_size,
      },
    };
  },
});

const handleGetOrganizationsRequest = sagasHandlersFactory.createGetManyRequestHandler({
  actions: actions.getOrganizations,
  request: OrganizationsApi.getOrganizations,
  requestArgsBuilder: function* builder(action) {
    const { params } = action.payload;
    const { page_size, ...rest } = params;
    const { page } = yield call(getNextPageParams, page_size, selectors.getOrganizationsState(), params);
    return {
      params: {
        ...rest,
        page,
        page_size,
      },
    };
  },
});

export default function* organizationsSagas() {
  yield takeEvery(actions.getOrganization.request.type, handleGetOrganizationRequest);
  yield takeEvery(actions.getOrganizationBySlug.request.type, handleGetOrganizationBySlugRequest);
  yield takeEvery(actions.getSearchOrganizations.request.type, handleGetSearchOrganizationsRequest);
  yield takeEvery(actions.getOrganizations.request.type, handleGetOrganizationsRequest);
}
